import { ButtonBase, Typography } from "@mui/material"
import Iconify from "minimals-template/components/Iconify"
import { If } from "lib/@components/switch"

export function RegimeSearchBreadcrumb({ item, next, onNavigate }) {
    return (
        <>
            <ButtonBase
                data-cy="regime-search-breadcrumb"
                disabled={!item.id}
                onClick={jump}
                sx={{
                    display: "inline-flex",
                    alignItems: "center",
                    gap: 0.75,
                    borderRadius: 1,
                    px: 0.5,
                    "&:hover": { bgcolor: "action.hover" },
                }}
            >
                <Iconify icon={item.icon} sx={{ width: 18, height: 18, color: "text.secondary", flexShrink: 0 }} />
                <Typography variant="body2" sx={{ color: "text.secondary", whiteSpace: "nowrap" }}>
                    {item.label}
                </Typography>
            </ButtonBase>
            <If value={!!next}>
                <Typography variant="body2" sx={{ color: "text.disabled", mx: 0.25 }}>
                    ›
                </Typography>
            </If>
        </>
    )

    function jump() {
        onNavigate(item)
    }
}
